const getPhones = (axios) => async (clinicReferenceId) => {
  const { data } = await axios.get("/api/phones", {
    params: {
      clinicReferenceIds: clinicReferenceId,
      unassigned: false
    }
  });
  return (data == null ? void 0 : data.content) || [];
};
export {
  getPhones
};
